import {createSelector} from 'reselect'
import {selectIndexingState} from '../../app/selectors'
import {IndexingState} from './indexing.reducer'

export const selectResult = createSelector(selectIndexingState, (state: IndexingState) => state.result)
